import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { Trophy, Crown } from "lucide-react";
import api from "@/lib/api";
import { TeamLogo } from "@/components/tournament/BracketView";

const TOP = ["#facc15", "#cbd5e1", "#d97706"];
const COLS = "grid-cols-[2rem_1fr_5.5rem_3rem]";

function Row({ r, i }) {
  return (
    <motion.div initial={{ opacity: 0, y: 8 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: Math.min(i, 10) * 0.04 }}
      className={`grid ${COLS} items-center gap-2 px-4 py-3 hover:bg-white/5 transition-colors`} data-testid={`leaderboard-row-${r.rank}`}>
      <span className="font-head text-base font-bold" style={{ color: TOP[r.rank - 1] || "rgba(255,255,255,0.35)" }}>{r.rank}</span>
      <div className="flex items-center gap-2 min-w-0">
        <TeamLogo team={r.team} logos={{ [r.team]: r.logo }} size="w-7 h-7" />
        <span className="text-sm font-semibold text-white truncate" data-testid={`leaderboard-team-${r.rank}`}>{r.team}</span>
        {r.rank === 1 && <Crown size={13} className="text-yellow-400 shrink-0" />}
      </div>
      <span className="text-xs text-white/60 truncate" data-testid={`leaderboard-country-${r.rank}`}>{r.country || "—"}</span>
      <span className="text-right text-sm font-bold text-white" data-testid={`leaderboard-wins-${r.rank}`}>{r.wins}</span>
    </motion.div>
  );
}

export default function TeamLeaderboard() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/leaderboard").then((r) => setItems(r.data.items)).catch(() => setItems([])).finally(() => setLoading(false));
  }, []);

  return (
    <section className="card-surface rounded-2xl overflow-hidden" data-testid="team-leaderboard">
      <h3 className="px-4 pt-4 pb-3 font-bold text-white flex items-center gap-2"><Trophy size={16} className="text-yellow-400" /> Team Leaderboard</h3>
      <div className={`grid ${COLS} gap-2 px-4 py-2 text-[10px] uppercase tracking-widest text-white/40 border-y border-white/5`}>
        <span>No</span><span>Team</span><span>Country</span><span className="text-right">Wins</span>
      </div>
      <div className="divide-y divide-white/5">
        {loading ? <div className="p-5 text-sm text-white/40">Loading…</div>
          : items.length ? items.slice(0, 10).map((r, i) => <Row key={r.team} r={r} i={i} />)
          : <div className="p-5 text-sm text-white/50" data-testid="leaderboard-empty">No finished tournaments yet.</div>}
      </div>
    </section>
  );
}
